<template>
  <div>
    <v-btn v-on:click="selector = true"><v-icon>mdi-music-note</v-icon> {{ titleSelect }}</v-btn>
    <span v-if="!value"><v-icon>mdi-music-note-off</v-icon>No audio</span>
    <AudioButton v-if="value" :src="value" />
  </div>
</template>

<script>
import AudioButton from './AudioButton'

export default {
  components: { AudioButton },
  props: ['value', 'suggest'],
  data () {
    return {
      selector: false
    }
  },
  computed: {
    titleSelect () {
      return this.value ? 'Change pronunciation' : 'Choose pronunciation'
    }
  }
}
</script>
